import { chunkArray } from '@diritto/common/utils/array';
import { useQueries } from '@tanstack/react-query';
import { ReplyApi } from 'api/ApiHelper';
import { repliesQueryKey } from 'queries/reply/queryKey';
import { useMemo } from 'react';

export const useGetLikedRepliesQueries = (replyIds: number[], enabled = false) => {
  const chunkedReplyIds = useMemo(() => chunkArray(replyIds, 20), [replyIds]);
  const queries = useMemo(
    () => ({
      queries: chunkedReplyIds.map(chunkedReplyId => ({
        queryKey: repliesQueryKey.replyLikeList(chunkedReplyId),
        queryFn: () => ReplyApi.getReplyLikes(chunkedReplyId),
        enabled,
      })),
    }),
    [chunkedReplyIds, enabled],
  );

  return useQueries(queries);
};
